module.exports = __webpack_public_path__ + "img/step10.08aafd35.png";